import { Group, Title, Button } from '@mantine/core';
import { IconGridDots } from '@tabler/icons-react';
import React from 'react';
import DataTable from 'react-data-table-component';
import useGetMatch from './useGetMatch';
import LoadingErrorContainer from '../../components/placeholders/LoadingErrorContainer';
import UserRow from './components/UserRow';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { exportMatches } from '../../api/match';


dayjs.extend(utc);
dayjs.extend(timezone);


const Remote = () => {

    const { MatchQuery: {
        data, isPending, isError, isRefetching },
        totalRows,
        handleChangePerPage,
        handlePageChange,
        search,
        setSearch
    } = useGetMatch()


    const columns = [

        {
            name: 'User Name',
            selector: row => row.user.tiktok_username,
            //sortable: true,
            cell: row => <UserRow row={row.user} />,
            width: "300px",
        },
        {
            name: 'Opponent Name',
            selector: row => row.opponent.tiktok_username,
            //sortable: true,
            cell: row => <UserRow row={row.opponent} />,
            width: "300px",
        },
        {
            name: 'Match Style',
            selector: row => row.match_style ? row.match_style?.name : 'N/A',
            // sortable: true,
        },
        {
            name: 'Is More Visible',
            selector: row => row.is_more_visible ? 'Yes' : 'No',
            sortable: true,
        },

        {
            name: 'Match Time',
            selector: row => {
                // Parse the UTC time and convert to local time
                const localTime = dayjs.utc(row.match_confirm_time).local().format('D MMM YYYY, HH:mm:ss');
                return localTime;
            },
            sortable: true,
        },

    ];

    const handleClick = async () => {
        try {
            // Call the `exportUsers` API function
            const response = await exportMatches();

            if (response?.data?.filename) {
                const url = response.data.filename;

                // Create an anchor element to trigger the download
                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = 'match.xlsx'; // Suggest a filename
                anchor.click();
            } else {
                console.error('No filename returned in the response.');
            }
        } catch (error) {
            console.error('Error exporting match:', error);
        }
    };



    return (
        <LoadingErrorContainer isError={isError} isLoading={isPending} isRefetching={isRefetching}>
            <Group justify='space-between'>
                <Title order={3}>Confirmed Matches</Title>

                <Button
                    onClick={handleClick}
                    variant="gradient"
                    gradient={{ from: '#44FFFA', to: '#FF4267', deg: 90 }}
                    leftSection={<IconGridDots style={{ width: '1rem', height: '1rem', alignSelf: "flex-end" }} />}

                >Export Match </Button>

            </Group>
            <DataTable
                columns={columns}
                data={data?.data ?? []}
                progressPending={isPending}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handleChangePerPage}
                onChangePage={handlePageChange}



            // selectableRows

            />

        </LoadingErrorContainer>


    );

}

export default Remote;
